"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadOnlyRegistry = void 0;
const AbstractKeyRegistry_1 = require("./AbstractKeyRegistry");
const constants_1 = require("../../lib/constants");
const util_1 = require("../../lib/util");
class ReadOnlyRegistry extends AbstractKeyRegistry_1.AbstractKeyRegistry {
    constructor(connection, address, seedPrefix, cluster) {
        super(address, seedPrefix, cluster);
        this.program = (0, util_1.makeProgram)(connection, constants_1.dummyAuthority);
    }
    static for(publicKey, connection, cluster = "mainnet-beta") {
        return new ReadOnlyRegistry(connection, publicKey.toBuffer(), AbstractKeyRegistry_1.KEY_REGISTRY_SEED_PREFIX, cluster);
    }
    static forEthAddress(ethAddress, connection, cluster = "mainnet-beta") {
        const trimmedEthAddress = ethAddress.substring(2); // without 0x
        return new ReadOnlyRegistry(connection, Buffer.from(trimmedEthAddress, "hex"), AbstractKeyRegistry_1.ETH_KEY_REGISTRY_SEED_PREFIX, cluster);
    }
}
exports.ReadOnlyRegistry = ReadOnlyRegistry;
//# sourceMappingURL=ReadOnlyRegistry.js.map